<template>
    <svg xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke-width="1.5" 
            :stroke="strokeColor" 
            class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
    </svg>
</template>
    
<script setup>
    import { defineProps, computed } from 'vue';

    const props = defineProps(['stroke'])

    const strokeColor = computed(() => {
        return props.stroke ? props.stroke : 'black'
    })
</script>